
import { useEffect } from 'react';
import { useTerraceData } from './admin/useTerraceData';
import { useTerraceOperations } from './admin/useTerraceOperations';
import { AdminTerraceOperations } from './admin/types';

export const useAdminTerraces = (): AdminTerraceOperations => {
  const {
    terraces,
    loading,
    error,
    fetchTerraces
  } = useTerraceData();

  const {
    updateTerrace,
    deleteTerrace
  } = useTerraceOperations(fetchTerraces);

  useEffect(() => {
    fetchTerraces();
  }, []);

  return {
    terraces,
    loading,
    error,
    fetchTerraces,
    updateTerrace,
    deleteTerrace
  };
};
